import React from 'react';
import PropTypes from 'prop-types';

import SimplePageTemplate from '../../static-page/components/SimplePageTemplate';

import LinkList from '../../../common/components/LinkList';

import './AllSearchList.scss';

const AllSearchList = ({ searchLinkList }) => {
  const list = searchLinkList.map(({ title, url }) => ({
    id: url,
    title,
    url
  }));

  return (
    <SimplePageTemplate title="Search Sitemap">
      <LinkList className="search-list" list={list} />
    </SimplePageTemplate>
  );
};

AllSearchList.propTypes = {
  searchLinkList: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string
  }).isRequired
};

export default AllSearchList;
